export default "__VITE_ASSET__791e4817__"